import axios from "@common/axios";
import {objectHasEntry} from "@common/utilityFunctions";
import {isCancel} from "axios";

export const searchTestQuestionsPaged = (params, handleTableData, handlePagingData, abortController) => {
    const {pageSize, pageNumber, ...testQuestionSearchParams} = params;
    if (!isNaN(pageSize) && !isNaN(pageNumber) && objectHasEntry(testQuestionSearchParams)) {
        axios.post('/web/ui/test/teacher/searchTeacherTestQuestionsPaged', testQuestionSearchParams, {
            params: {
                pageSize: pageSize,
                pageNumber: pageNumber
            }, signal: abortController.signal
        }).then(response => {
            if (response && response.data) {
                handleTableData(response.data.currPageContents);
                const {pageSize, totalResults} = response.data;
                let {currPage} = response.data;
                handlePagingData({currPage, pageSize, totalResults});
            }
        }).catch((error) => {
            if(!isCancel(error)){
                console.error('Missing params values for searchTeacherTestQuestionsPaged.');
                displayToastMessage('Error finding test questions', error.response.data.message, 'error', undefined, 10000);
            }
        }).finally(()=>{
            abortController = null;
        });
    }
}
export const getAndSetTestData = (testId)=> {
    return axios.get('/web/ui/test/teacher/edit',{params:{ testId: testId }})
        .then(response =>{
            return response.data;
        }).catch(error =>{
            console.error('Error retrieving test: ', error);
            return {};
        });
}

export const teacherCreateTest = (params)=> {
    return axios.post('/web/ui/test/teacher/createTest',null,{params:params })
        .then(response =>{
            return response.data;
        }).catch(error =>{
            console.error('Error retrieving test: ', error);
            return {error:error};
        });
}

export const getAndSetTestQuestionData = (testId)=> {
    return axios.get('/web/ui/test/getTestQuestions',{params:{ testId: testId }})
        .then(response =>{
            if(response.data){
                return response.data;
            }
        }).catch(error =>{
            console.error('Error retrieving test: ', error);
            return {};
        })
}

export const getDiagnosticSkillSummary = (testId)=> {
    return axios.get('/web/ui/test/teacher/getDiagnosticSkillSummary',{params:{ testId: testId }})
        .then(response =>{
            if(response.data){
                return response.data.skillSummaryBeans;
            }
        }).catch(error =>{
            console.error('Error getting skill summary: ', error);
            return [];
        })
}

export const saveTestData = ({params, body, callback, brandConfigTestName})=> {
    axios.post('/web/ui/test/teacher/saveTest',body,{params:params}).then(()=>{
        displayToastMessage("Success", 'Your '+brandConfigTestName+' has been saved successfully', 'success', 300);
    }).catch((error)=>{
        let errorMessage = 'Your '+brandConfigTestName+' test has not been saved',
            icon = "Error"
        if (error.response && error.response.data && error.response.data.message) {
            errorMessage = error.response.data.message;
            icon = "Warning";
        }
        displayToastMessage(icon, errorMessage, icon.toLowerCase(), 300,8000);
    }).finally(()=>{
        callback();
    })
}

export const saveName = (params, callback, brandConfigTestName) =>{
    axios.post('/web/ui/test/teacher/saveTestName',null,{params:params}).catch((error)=>{
        console.error('Error saving test name: ',error);
        displayToastMessage("Error", 'Your '+brandConfigTestName+' name has not been saved', 'error', 300);
    }).finally(()=>{
        callback();
    })
}
export const saveDescription = (params, callback, brandConfigTestName) =>{
    axios.post('/web/ui/test/teacher/saveTestDescription',null,{params:params}).catch((error)=>{
        console.error('Error saving test description: ',error);
        displayToastMessage("Error", 'Your '+brandConfigTestName+' description has not been saved', 'error', 300);
    }).finally(()=>{
        callback();
    })
}


export const getUserSyllabusGroups = (params)=> {
    return axios.get('/web/ui/content/findUserSyllabusGroups',{params:{ forTests: true, hasQuestions:true, ...params }})
        .then(response =>{
            return response.data;
        }).catch(error =>{
            console.error('Error retrieving test: ', error);
            return [];
        });
}

export const getSyllabusesByUserBrandGroup = (params)=> {
    return axios.get('/web/ui/content/findSyllabusesByUserBrandGroup',{params:{ forTests: true, hasQuestions:true, ...params }})
        .then(response =>{
            return response.data;
        }).catch(error =>{
            console.error('Error retrieving test: ', error);
            return [];
        });
}

export const getUserTopics = (params)=> {
    return axios.get('/web/ui/content/findTopicsForSyllabus',{params:{ forTests: true, hasQuestions: true, ...params }})
        .then(response =>{
            return response.data;
        }).catch(error =>{
            console.error('Error retrieving test: ', error);
            return [];
        });
}

export const getUserTopicGroups = (params)=> {
    return axios.get('/web/ui/content/syllabus/topicGroups',{params:{ hasTopics: true, ...params }})
        .then(response =>{
            return response.data;
        }).catch(error =>{
            console.error('Error retrieving test: ', error);
            return [];
        });
}

export const getUserTopicsByTopicGroup = (params)=> {
    return axios.get('/web/ui/content/topicGroup/topics',{params:{ forTests: true, hasQuestions: true, ...params }})
        .then(response =>{
            return response.data;
        }).catch(error =>{
            console.error('Error retrieving test: ', error);
            return [];
        });
}

export const getUserConcepts = (params)=> {
    return axios.get('/web/ui/content/findConceptsForTopic',{params:{ forTests: true, hasQuestions: true, ...params }})
        .then(response =>{
            return response.data;
        }).catch(error =>{
            console.error('Error retrieving test: ', error);
            return [];
        });
}

export const getUserSkillsByConcept = (conceptId)=> {
    return axios.get('/web/ui/content/concept/skills',{params:{ conceptId: conceptId }})
        .then(response =>{
            return response.data;
        }).catch(error =>{
            console.error('Error retrieving test: ', error);
            return [];
        });
}

export const getSyllabusLink = (params)=>{
    return axios.get('/web/ui/nav/getSyllabusLink',{params:{syllabusId:params.syllabusId}})
        .then(response =>{
            return response.data;
        }).catch(error =>{
        console.error('Error retrieving test: ', error);
        return [];
    });
}

export const editTestQuestionInCMS = ({questionId, groupQuestionDepth, groupQuestionId, questionClusterId}, useReact)=>{
    /* Edited from generalLessonScripts.js addEditQuestionLinks*/
    let editQuestionUrl = '/administration/question/manageQuestions.action',
        editQuestionUrlParams = '?questionId=' + questionId + '#editQuestion',
        editQuestionParamsObj = {questionId: questionId};

    if (questionClusterId !== undefined) {
        editQuestionUrl = '/administration/question/manageQuestionClusters.action';
        editQuestionUrlParams = '?questionClusterId=' + questionClusterId + '&groupQuestionId=' + groupQuestionId + '&groupQuestionDepth=' + groupQuestionDepth + '&questionId=' + questionId + '#editQuestion';
        editQuestionParamsObj = {questionClusterId: questionClusterId, groupQuestionId: groupQuestionId, groupQuestionDepth: groupQuestionDepth, questionId: questionId};
    }

    if (useReact) {
        if (globalReactFunctions !== undefined && globalReactFunctions.loadShortcutByUrl !== undefined) {
            if (questionClusterId !== undefined) {
                globalReactFunctions.questionClusterTabsActiveTab = 3;
            } else {
                globalReactFunctions.questionTabsActiveTab = 1;
            }
            globalReactFunctions.loadShortcutByUrl(editQuestionUrl, editQuestionParamsObj);
        }
    } else {
        document.location.href = editQuestionUrl + editQuestionUrlParams;
    }
}